<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      <div class="text-center">
        Carregando dados...
      </div>
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacao"
                style="text-align: center;"
              />
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Grupo do Produto
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Faturamento
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Fat. Mês do Ano Anterior
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Variação de Fat. Anual
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Participação da Linha
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Quantidade
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Preço Médio
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in faturamentoGrupoProdutos"
            :key="item.id"
          >
            <!-- Linha principal -->
            <tr>
              <td style="text-align: center;">
                <button @click="toggleExpand(index)">
                  {{ expanded.includes(index) ? '▲' : '▼' }}
                </button>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.grupo_produto }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.faturamento }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.faturamento_anterior }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                <v-chip
                  :color="getColor(item.variacao_anual)"
                  dark
                >
                  {{ item.variacao_anual }}
                </v-chip>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.participacao_grupo }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.volume }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.preco_medio }}
              </td>
            </tr>
            <!-- Linha expandida -->
            <tr
              v-if="expanded.includes(index)"
              :key="'expanded-' + item.id"
            >
              <td colspan="8">
                <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Produto
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Faturamento
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Fat. Mês do Ano Anterior
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Variação de Fat. Anual
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Participação do produto
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Quantidade
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Preço Médio
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(sub, idx) in item.dadosProduto"
                      :key="idx"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.produto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.faturamento_anterior }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        <v-chip
                          :color="getColor(sub.variacao_anual)"
                          dark
                        >
                          {{ sub.variacao_anual }}
                        </v-chip>
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.participacao_grupo }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.volume }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.preco_medio }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Produto from '../../../../../services/analiseproduto2'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['setDadosGrupoProduto'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      headersGrupoProdutos: [
        { text: 'Grupo do Produto', value: 'grupo_produto', width: '20%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês do Ano Anterior', value: 'faturamento_anterior', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual', value: 'variacao_anual', width: '10%', align: 'right', class: 'black--text title' },
        { text: 'Participação da Linha', value: 'participacao_grupo', width: '10%', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'volume', width: '10%', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'preco_medio', width: '10%', align: 'right', class: 'black--text title' },
      ],
      headersProdutos: [
        { text: 'Produto', value: 'produto', width: '20%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês do Ano Anterior', value: 'faturamento_anterior', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual', value: 'variacao_anual', width: '10%', align: 'right', class: 'black--text title' },
        { text: 'Participação do produto', value: 'participacao_grupo', width: '10%', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'volume', width: '10%', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'preco_medio', width: '10%', align: 'right', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      expanded: [],
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.vendedor = vendedores
        this.area = areas
        this.rede = redes
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento

        this.showFaturamentoGrupoProdutos()
      },

      async showFaturamentoGrupoProdutos () {
        this.loading = true

        this.faturamentoGrupoProdutos = []
        this.expanded = []

        await Produto.showAnaliseFaturamentoGrupoProdutosClassificacao(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoGrupoProdutos = resposta.data.faturamento.map((item) => {
              var listaFaturamento = ({
                grupo_produto: item.grupo_produto,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento_anterior: item.faturamento_anterior ? parseFloat(item.faturamento_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                variacao_anual: item.variacao_anual ? parseFloat(item.variacao_anual).toFixed(2) + '%' : '-',
                participacao_grupo: item.participacao_grupo ? parseFloat(item.participacao_grupo).toFixed(2) + '%' : '-',
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                expandir: item.expandir,
                dadosProduto: this.dadosProdutos(item.dadosProdutos),
              })

              return listaFaturamento
            })

            eventEmit.$emit('set-dados-grupo-produto', this.faturamentoGrupoProdutos)
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosProdutos (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            produto: item.grupo_produto,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamento_anterior: item.faturamento_anterior ? parseFloat(item.faturamento_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
            variacao_anual: item.variacao_anual ? parseFloat(item.variacao_anual).toFixed(2) + '%' : '-',
            participacao_grupo: item.participacao_grupo ? parseFloat(item.participacao_grupo).toFixed(2) + '%' : '-',
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      getColor (value) {
        if (value < '0%') {
          return 'red'
        } else {
          return 'green'
        }
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #grupoProdutos {
      font-size: 10px;
      max-width: 100%
    }

    #idTable {
      max-height: 500px;
      max-width: 360px !important;
      margin: 0 0 0 -1rem;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #grupoProdutosId {
      width: 100%;
    }

    #grupoProdutos {
      font-size: 10px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #grupoProdutos
    data-table-scroll-bar-width: 17px

</style>
